import React from "react";
import { PropTypes } from "prop-types";
import { Grid, Chip } from "@mui/material";
import Reference from "./Reference";
import TransactionAddress from "./TransactionAddress";
import LinkedTransaction from "./LinkedTransaction";
import CustomFields from "./CustomFields";
import TaxInfo from "./TaxInfo";
import WorkCenter from "./WorkCenter";
import CompanyAddress from "./CompanyAddress";
import Contact from "./Contact";
import CustomerTaxStatus from "./CustomerTaxStatus";
import ItemUnitOfMeasure from "./ItemUnitOfMeasure";
import PriceTier from "./PriceTier";
import WarrantyInfo from "./WarrantyInfo";
import { withStyles } from "@mui/styles";

const StyledChip = withStyles({
  root: {
    marginLeft: "10px",
    marginBottom: "3px",
    height: 20,
    padding: "6px 0 8px 0",
    fontFamily: ["futura-pt, sans-serif"].join(","),
  },
  outlined: {
    border: "1px solid #666",
    color: "#666",
    fontSize: 14,
    fontWeight: 400,
  },
})(Chip);

export default function ApiAttribute(props) {
  const { name, type, description, readOnly, newField } = props;
  var displayType;
  switch (type) {
    case "reference":
      displayType = <Reference type={type} />;
      break;
    case "transaction address":
      displayType = <TransactionAddress type={type} />;
      break;
    case "company address":
      displayType = <CompanyAddress type={type} />;
      break;
    case "contact":
      displayType = <Contact type={type} />;
      break;
    case "linked transaction type":
      displayType = <LinkedTransaction type={type} />;
      break;
    case "array of custom fields":
      displayType = <CustomFields type={type} />;
      break;
    case "tax information object":
      displayType = <TaxInfo type={type} />;
      break;
    case "array of workcenters":
      displayType = <WorkCenter type={type} />;
      break;
    case "customer tax status":
      displayType = <CustomerTaxStatus type={type} />;
      break;
    case "array of item units of measure":
      displayType = <ItemUnitOfMeasure type={type} />;
      break;
    case "array of price tiers":
      displayType = <PriceTier type={type} />;
      break;
    case "warranty information":
      displayType = <WarrantyInfo type={type} />;
      break;

    default:
      displayType = <span className={"type"}>{type}</span>;
  }

  return (
    <>
      <Grid container spacing={0} className={"attribute"}>
        <Grid item xs={12}>
          <span className={"name"}>{name}</span>
        </Grid>
        <Grid item xs={12}>
          {displayType}
          {readOnly && (
            <StyledChip variant="outlined" size="small" label="read-only" />
          )}
          {newField && (
            <StyledChip variant="outlined" size="small" label={newField} />
          )}
        </Grid>
        <Grid item xs={12}>
          <p className={"description"}>{description}</p>
        </Grid>
      </Grid>
    </>
  );
}
ApiAttribute.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  description: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
};
